"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateCharABC = void 0;
/**
 * This migration got introduced because we need to make character ids consts (a,b,c) instead of {walletAddress}:{tokenId}
 * This enables for the character swap feature
 */
const migrateCharABC = async (story) => {
    // idsMapping = { [{walletAddress}:{tokenId}]: 'a' | 'b' | 'c' };
    const idsMapping = story.characters.reduce((res, cur) => {
        if (!res[cur.id]) {
            const keys = Object.keys(res);
            const id = keys.length === 0 ? 'a' : keys.length === 1 ? 'b' : 'c';
            res[cur.id] = id;
        }
        return res;
    }, {});
    let storyStr = JSON.stringify(story);
    for (const oldId of Object.keys(idsMapping)) {
        storyStr = storyStr.replace(new RegExp(oldId, 'g'), idsMapping[oldId]);
    }
    const newStory = JSON.parse(storyStr);
    newStory.characters = newStory.characters.reduce((res, cur) => ({
        ...res,
        [cur.id]: cur
    }), {});
    return newStory;
};
exports.migrateCharABC = migrateCharABC;
//# sourceMappingURL=migrateCharABC.js.map